import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import urls from "../../config/urls.json";
import { useSession } from "../../hooks/useSession";
import { useStates } from "../../hooks/useStates";
import { ApiService as api } from "../../services/ApiService";
import { isName, isEmail, isPhone, isCap, isCf } from "../../services/validators";
import { useDynatrace } from "../../hooks/useDynatrace";
import { useEditAppointment } from "../../hooks/useEditAppointment";
import { useAppointmentResponse } from "../../hooks/useAppointmentResponse";

export const useClinkDirectPage = () => {
    const navigate = useNavigate();
    const { read, update, batchUpdate, getClinkDirectAppointmentPayload } = useSession();
    const { states, setCurrentState, isDatiUtenteReady, isCfFetchStart, isFilialiSlideBusy } = useStates();
    const { showModal, closeModal } = useEditAppointment();
    const [fetchError, setFetchError] = useState(false);
    const { isCreaAppuntamentoBusy, fetchErrorMessage, setFetchErrorMessage } = useAppointmentResponse();
    const [appointmentCompleted, setAppointmentCompleted] = useState(false);

    useEffect(() => {
        setCurrentState(states.LOAD_FILIALI_SLIDES_END);
        // update("codiceFiscale", "");
    }, []);

    const {} = useDynatrace();

    const checkDataBeforeSubmit = () => {
        let result = 1;
        let focusOn = "";
        let focusOnError = ".full-form-appto-error";
        let focusOnPosition = "center";

        if (read("privacyInterncommoffer") != "1") {
            focusOn = ".tos-sic";
            focusOnError = ".tos-list-component-sic-appto-error";

            result *= 0;
        }

        for (let tos of ["privacyExtcommoffer", "privacyOtherservice", "privacyProfilazione"]) {
            if (!read(tos)) {
                focusOn = ".tos-list-component";
                focusOnPosition = "start";
                focusOnError = ".tos-list-component-appto-error";

                result *= 0;
                break;
            }
        }

        // fields
        if (!isName(read("nome")) || !isName(read("cognome"))) {
            focusOn = ".full-form";
            focusOnError = ".full-form-appto-error";
            result *= 0;
        }
        if (!isEmail(read("email"))) {
            focusOn = ".full-form";
            focusOnError = ".full-form-appto-error";
            result *= 0;
        }
        if (!isPhone(read("cellulare"))) {
            focusOn = ".full-form";
            focusOnError = ".full-form-appto-error";
            result *= 0;
        }
        if (!isCap(read("cap"))) {
            focusOn = ".full-form";
            focusOnError = ".full-form-appto-error";
            result *= 0;
        }
        if (!isCf(read("codiceFiscale"))) {
            focusOn = ".full-form";
            focusOnError = ".full-form-appto-error";
            result *= 0;
        }

        if (result == 0) {
            let destinationNode = document.querySelector(focusOn);
            if (null != destinationNode) {
                destinationNode.scrollIntoView({
                    behavior: "smooth",
                    block: focusOnPosition,
                });
            }

            if (null != document.querySelector(`.crea-appto-error${focusOnError}`)) {
                document.querySelector(`.crea-appto-error${focusOnError}`).classList.remove("hidden");
            }
        }

        return result > 0;
    };

    const next = async () => {
        if (read("cfErrorInForm")) {
            console.log("blocca");
            setFetchErrorMessage("Nome e cognome non coincidono con il codice fiscale");
            setFetchError(true);
            return false;
        }

        const isReady = checkDataBeforeSubmit();

        if (!isReady) return false;

        setCurrentState(states.CREA_APPUNTAMENTO_START);

        // se il form è ok
        // 1. api.checkcap
        const checkCapRes = await api.AgenteVerificaCapCFCLink({
            cf: read("codiceFiscale"),
            cap: read("cap"),
            // CodHub: read("hubAgente"),
        });

        // 2. se cap ok
        if (read("agente_direct_clink_pluri") == true || ("0" == checkCapRes.Status && checkCapRes.Data.Ricontatto)) {
            // @test agente pluri
            let creaApptoRes = null;
            if (read("agente_direct_clink_pluri") == true) {
                creaApptoRes = await api.InviaSuLeadManager({
                    ...getClinkDirectAppointmentPayload(read("agente_direct_clink")),
                });
            } else {
                creaApptoRes = await api.AgenteCreaAppuntamentoCLink({
                    ...getClinkDirectAppointmentPayload(read("agente_direct_clink")),
                });
            }

            console.log(creaApptoRes);

            if ("0" == creaApptoRes.Status) {
                setCurrentState(states.CREA_APPUNTAMENTO_END);
                setAppointmentCompleted(true);
                window.scrollTo(0, 0);
            } else {
                setCurrentState(states.CREA_APPUNTAMENTO_ERROR);
                setFetchErrorMessage("C'è stato un errore nella creazione del tuo appuntamento. <br />Per favore riprova.");
                setFetchError(true);
            }
        } else {
            const coordinate = await api.getCoordsByCap(read("cap"));
            let filialiResult = {};
            try {
                filialiResult = await api.TrovaFiliali3({
                    cap: read("cap"),
                    latitude: coordinate.lat,
                    longitude: coordinate.lng,
                    city: coordinate.locality,
                    placeType: read("placeType") || "",
                });
            } catch (error) {
                setFetchErrorMessage("C'è stato un errore nella ricerca delle filiali. <br />Per favore riprova.");
                setFetchError(true);
                return;
            }

            batchUpdate({
                filiali: filialiResult.filiali,
                filialeScelta: filialiResult.filiali[0],
                disponibilita: filialiResult.filiali[0].days,
                dataScelta: filialiResult.filiali[0].days[0],
                ricontattoLuogo: filialiResult.ricontatto,
            });

            // 3. chiedere disponibilita per prima filiale e primo giorno
            let disponibilitaResult = {};
            try {
                disponibilitaResult = filialiResult.filiali[0];
            } catch (error) {
                setFetchErrorMessage("C'è stato un errore nella ricerca delle filiali. <br />Per favore riprova.");
                setFetchError(true);
                return;
            }

            batchUpdate({
                orari: disponibilitaResult.orariDisponibili,
                orarioScelto: disponibilitaResult.orariDisponibili.filter((_) => _.disponibile == true)[0],
            });

            // setCurrentState(states.CREA_APPUNTAMENTO_ERROR);
            setCurrentState(states.FETCH_FILIALI_END);
            navigate(urls.filiali.path, { replace: true, state: { clinkDirectTitle: true } });
        }
    };

    return {
        next,
        read,
        update,
        isFilialiSlideBusy,
        fetchErrorMessage,
        fetchError,
        isDatiUtenteReady,
        isCfFetchStart,
        showModal,
        closeModal,
        isCreaAppuntamentoBusy,
        appointmentCompleted,
        setFetchError,
        setFetchErrorMessage,
    };
};
